import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-form-view',
  templateUrl: './form-view.component.html',
})
export class FormViewComponent implements OnInit {
  
  @Input() title:string;
  @Input() icon:string;
  @Input("confirmar") _confirmar = () => {};
  @Input("cancelar") _cancelar = () => {};

  constructor() { }

  ngOnInit() {
  }

  cancelar(){
    if(this._cancelar){
      this._cancelar();
    }
  }
  
  confirmar(){
    if(this._confirmar){
      this._confirmar();
    }
  }

}
